import { IntlShape } from "react-intl"
import { array, lazy, object } from "yup";
import { ControlTypes } from "./ReportMetadata.model";
import FormValidator from "../../util/FormValidator.util";

export default class ReportMetadataFormValidator extends FormValidator{
  constructor(public readonly intl: IntlShape) {
    super(intl)
  }

  public validate() {
    return object().shape({
      items: array().of(
        lazy((item) => {
          const innerArrayObject = () => {
            return array().of(
              lazy((item) => {
                if (!item || !item.type) {
                  return object({items: innerArrayObject()})
                }

                if (item.type === ControlTypes.DATE) {
                  return object({value: this.validateInputDate()})
                }

                if (item.type === ControlTypes.INPUT_TEXT) {
                  return object({value: this.validateInputText()})
                }

                if (item.type === ControlTypes.INPUT_NUMBER) {
                  return object({value: this.validateInputNumber()})
                }

                if (item.type === ControlTypes.TEXTAREA) {
                  return object({value: this.validateTextArea()})
                }

                if (item.type === ControlTypes.SINGLE_CHOICE) {
                  return object({selectValue: this.validateSingleChoice()})
                }

                return object({items: innerArrayObject()})
              })
            )
          }

          if (!item || !item.type) {
            return object({items: innerArrayObject()})
          }

          if (item.type === ControlTypes.DATE) {
            return object({value: this.validateInputDate()})
          }

          if (item.type === ControlTypes.INPUT_TEXT) {
            return object({value: this.validateInputText()})
          }

          if (item.type === ControlTypes.INPUT_NUMBER) {
            return object({value: this.validateInputNumber()})
          }

          if (item.type === ControlTypes.TEXTAREA) {
            return object({value: this.validateTextArea()})
          }

          if (item.type === ControlTypes.SINGLE_CHOICE) {
            return object({selectValue: this.validateSingleChoice()})
          }

          return object({items: innerArrayObject()})
        })
      ),
    })
  }

  public validateStrict() {
    return object().shape({
      items: array().of(
        lazy((item) => {
          const innerArrayObject = () => {
            return array().of(
              lazy((item) => {
                if (!item || !item.type) {
                  return object({items: innerArrayObject()})
                }

                if (item.type === ControlTypes.DATE) {
                  return object({value: this.validateInputDateStrict()})
                }

                if (item.type === ControlTypes.INPUT_TEXT) {
                  return object({value: this.validateInputTextStrict()})
                }

                if (item.type === ControlTypes.INPUT_NUMBER) {
                  return object({value: this.validateInputNumberStrict()})
                }

                if (item.type === ControlTypes.TEXTAREA) {
                  return object({value: this.validateTextAreaStrict()})
                }

                if (item.type === ControlTypes.SINGLE_CHOICE) {
                  return object({selectValue: this.validateSingleChoiceStrict()})
                }

                return object({items: innerArrayObject()})
              })
            )
          }

          if (!item || !item.type) {
            return object({items: innerArrayObject()})
          }

          if (item.type === ControlTypes.DATE) {
            return object({value: this.validateInputDateStrict()})
          }

          if (item.type === ControlTypes.INPUT_TEXT) {
            return object({value: this.validateInputTextStrict()})
          }

          if (item.type === ControlTypes.INPUT_NUMBER) {
            return object({value: this.validateInputNumberStrict()})
          }

          if (item.type === ControlTypes.TEXTAREA) {
            return object({value: this.validateTextAreaStrict()})
          }

          if (item.type === ControlTypes.SINGLE_CHOICE) {
            return object({selectValue: this.validateSingleChoiceStrict()})
          }

          return object({items: innerArrayObject()})
        })
      ),
    })
  }
}